import styled from "styled-components";

export const MainTemplateLoading = styled.div`
  margin: 20px 0;
  margin-bottom: 20px;
  padding: 200px 50px;
  text-align: center;
  border-radius: 4px;
`;
